/* TWRD filter drawer.

   Eet filtersystem for hele kollektionssiden. Skuffen og stoerrelses-pillerne
   over griddet skriver i den SAMME state og kalder den samme apply().
   twrd-collection-bar.js traeder til side naar window.TwrdFilters findes.

   Datagrundlag: snippets/twrd-filter-data.liquid printer HELE kollektionen som
   JSON i <script id="twrd-filter-dataset">. Filtrering, sortering og tal regnes
   paa det datasaet, ikke paa de kort der tilfaeldigvis er hentet ind i griddet.
   Kort for produkter paa senere sider bliver tegnet her. Saa kan kunden ikke se
   "0 products" for en kollektion der har traeffere.

   Er datasaettet ufuldstaendigt (flere produkter end Liquid kan naa), staar
   "partial": true i JSON'en. Har butikken native filtre, sender vi i stedet
   browseren til serverens egne filter.v.* parametre. Ellers filtrerer vi kun de
   hentede kort og siger det aabent i tallene.

   Facets: color, size, print, type, tag (multi-select, OR inden for gruppen,
   AND paa tvaers af grupper) og stock (til/fra). Sort er klientside og
   nulstilles naar temaet re-renderer griddet. */
(function () {
  'use strict';

  var FACETS = ['color', 'size', 'print', 'type', 'tag'];
  var SORTS = ['featured', 'newest', 'price-asc', 'price-desc'];
  var DATASET_ID = 'twrd-filter-dataset';

  /* Native Shopify-parametre til fallback-navigationen. */
  var NATIVE_PARAM = {
    color: 'filter.v.option.color',
    size: 'filter.v.option.size',
    print: 'filter.v.option.style',
    type: 'filter.p.product_type',
    tag: 'filter.p.tag'
  };
  var NATIVE_SORT = {
    featured: 'manual',
    newest: 'created-descending',
    'price-asc': 'price-ascending',
    'price-desc': 'price-descending'
  };

  var state = newState();
  var cache = { node: null, data: null };

  function newState() {
    return {
      color: [],
      size: [],
      print: [],
      type: [],
      tag: [],
      stock: false,
      sort: 'featured'
    };
  }

  /* ------------------------------------------------------------- rene dele -- */

  /* Samme normalisering som i Liquid: smaa bogstaver, bindestreg bliver
     mellemrum. Saa matcher "king-of-kings" og "King Of Kings" hinanden. */
  function norm(value) {
    return String(value == null ? '' : value).toLowerCase().replace(/-/g, ' ').trim();
  }

  function numberOf(value) {
    var parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }

  /* Vaerdier er pipe-indrammede, saa "black" ikke rammer "smoky black". */
  function hasToken(raw, value) {
    var list = raw == null || raw === '' ? '|' : String(raw);
    return list.indexOf('|' + value + '|') !== -1;
  }

  /* Ren: matcher eet produkt mod state. "skip" springer en gruppe over, saa
     antallet for den gruppe kan regnes som om den stod aaben. */
  function matchesProduct(product, filters, skip) {
    for (var i = 0; i < FACETS.length; i += 1) {
      var facet = FACETS[i];
      if (facet === skip) continue;
      var picked = filters[facet] || [];
      if (!picked.length) continue;
      var hit = false;
      for (var j = 0; j < picked.length; j += 1) {
        if (hasToken(product[facet], picked[j])) {
          hit = true;
          break;
        }
      }
      if (!hit) return false;
    }
    if (skip !== 'stock' && filters.stock && Number(product.stock) !== 1) return false;
    return true;
  }

  /* Ren: nyt array, input roeres ikke. */
  function filterProducts(products, filters) {
    var out = [];
    for (var i = 0; i < products.length; i += 1) {
      if (matchesProduct(products[i], filters, null)) out.push(products[i]);
    }
    return out;
  }

  /* Ren: en comparator der laeser tal gennem "read", saa den samme sortering
     virker paa baade JSON-poster og DOM-noder. */
  function comparatorFor(sortKey, read) {
    if (sortKey === 'newest') {
      return function (a, b) {
        return read(b, 'created') - read(a, 'created');
      };
    }
    if (sortKey === 'price-asc') {
      return function (a, b) {
        return read(a, 'price') - read(b, 'price');
      };
    }
    if (sortKey === 'price-desc') {
      return function (a, b) {
        return read(b, 'price') - read(a, 'price');
      };
    }
    return function (a, b) {
      return read(a, 'pos') - read(b, 'pos');
    };
  }

  function readRecord(record, field) {
    return numberOf(record[field]);
  }

  function readNode(node, field) {
    return numberOf(node.getAttribute('data-twrd-f-' + field));
  }

  /* Ren: nyt sorteret array. */
  function sortProducts(products, sortKey) {
    return products.slice().sort(comparatorFor(sortKey, readRecord));
  }

  /* Ren: nyt sorteret array af kort. Ingen DOM-flytning her. */
  function orderCards(cards, comparator) {
    return cards.slice().sort(comparator);
  }

  function isCard(node) {
    return !!node && typeof node.hasAttribute === 'function' && node.hasAttribute('data-twrd-f');
  }

  /* Ren: den komplette oenskede raekkefoelge for griddet. Elementer uden
     data-twrd-f (den redaktionelle tile, beskedrader) bliver paa deres egen
     faste plads. Kaldes med et snapshot, returnerer et nyt snapshot. */
  function planGrid(children, comparator) {
    var products = [];
    for (var i = 0; i < children.length; i += 1) {
      if (isCard(children[i])) products.push(children[i]);
    }
    var sorted = orderCards(products, comparator);
    var plan = [];
    var cursor = 0;
    for (var j = 0; j < children.length; j += 1) {
      if (isCard(children[j])) {
        plan.push(sorted[cursor]);
        cursor += 1;
      } else {
        plan.push(children[j]);
      }
    }
    return plan;
  }

  /* Ren: antal traeffere for eet valg, regnet som om gruppen stod aaben. */
  function countFor(products, filters, facet, value) {
    var hits = 0;
    for (var i = 0; i < products.length; i += 1) {
      var product = products[i];
      if (!matchesProduct(product, filters, facet)) continue;
      if (facet === 'stock') {
        if (Number(product.stock) === 1) hits += 1;
      } else if (hasToken(product[facet], value)) {
        hits += 1;
      }
    }
    return hits;
  }

  /* Ren: tallene skal vaere aerlige. "shown" er kort paa siden, "matches" er
     traeffere i hele kollektionen. Er de ikke ens, siger vi det. */
  function totalsText(shown, matches) {
    var label = matches === 1 ? 'product' : 'products';
    if (shown < matches) return 'Showing ' + shown + ' of ' + matches + ' ' + label;
    return matches + ' ' + label;
  }

  /* Ren: validerer og normaliserer datasaettet fra Liquid. */
  function parseDataset(raw) {
    if (!raw) return null;
    var data;
    try {
      data = JSON.parse(raw);
    } catch (error) {
      if (window.console && window.console.warn) {
        window.console.warn('TWRD: filter-datasaettet er ikke gyldig JSON.', error);
      }
      return null;
    }
    if (!data || !Array.isArray(data.products)) return null;
    return {
      total: numberOf(data.total) || data.products.length,
      loaded: numberOf(data.loaded) || data.products.length,
      partial: data.partial === true,
      nativeFilters: data.nativeFilters === true,
      products: data.products
    };
  }

  /* Ren: serverside-URL med Shopifys egne parametre. Bruges kun naar
     datasaettet er ufuldstaendigt OG butikken har native filtre. */
  function serverQuery(filters) {
    var parts = [];
    for (var i = 0; i < FACETS.length; i += 1) {
      var facet = FACETS[i];
      var picked = filters[facet] || [];
      for (var j = 0; j < picked.length; j += 1) {
        parts.push(encodeURIComponent(NATIVE_PARAM[facet]) + '=' + encodeURIComponent(picked[j]));
      }
    }
    if (filters.stock) parts.push('filter.v.availability=1');
    parts.push('sort_by=' + encodeURIComponent(NATIVE_SORT[filters.sort] || 'manual'));
    return parts.join('&');
  }

  /* --------------------------------------------------------------- DOM ----- */

  function root() {
    return document.querySelector('.twrd-cards') || null;
  }

  function drawer() {
    return document.querySelector('[data-twrd-fd]') || null;
  }

  function items(grid) {
    if (!grid) return [];
    return Array.prototype.slice.call(grid.querySelectorAll(':scope > .o-layout__item[data-twrd-f]'));
  }

  function valueOf(button) {
    return norm(button.getAttribute('data-twrd-value'));
  }

  function datasetOf() {
    var node = document.getElementById(DATASET_ID);
    if (!node) return null;
    if (cache.node === node) return cache.data;
    cache = { node: node, data: parseDataset(node.textContent) };
    return cache.data;
  }

  /* Et produkt som det ser ud fra et grid-kort. Samme form som JSON-posten. */
  function recordFromNode(node) {
    return {
      handle: node.getAttribute('data-twrd-f-handle') || '',
      color: node.getAttribute('data-twrd-f-color') || '|',
      size: node.getAttribute('data-twrd-f-size') || '|',
      print: node.getAttribute('data-twrd-f-print') || '|',
      type: node.getAttribute('data-twrd-f-type') || '|',
      tag: node.getAttribute('data-twrd-f-tag') || '|',
      price: numberOf(node.getAttribute('data-twrd-f-price')),
      created: numberOf(node.getAttribute('data-twrd-f-created')),
      pos: numberOf(node.getAttribute('data-twrd-f-pos')),
      stock: node.getAttribute('data-twrd-f-stock') === '1' ? 1 : 0
    };
  }

  /* Kort for et produkt der endnu ikke er hentet ind i griddet. Bevidst
     enkelt: billede, titel, pris. Bygges med DOM-kald, aldrig innerHTML. */
  function buildCard(record, grid) {
    var sample = grid.querySelector(':scope > .o-layout__item[data-twrd-f]:not(.twrd-xcard)');
    var item = document.createElement('div');
    item.className = (sample ? sample.className : 'o-layout__item') + ' twrd-xcard';
    item.setAttribute('data-twrd-f', '');
    item.setAttribute('data-twrd-f-handle', String(record.handle || ''));
    item.setAttribute('data-twrd-f-pos', String(record.pos || 0));
    item.setAttribute('data-twrd-f-price', String(record.price || 0));
    item.setAttribute('data-twrd-f-created', String(record.created || 0));
    item.setAttribute('data-twrd-f-stock', Number(record.stock) === 1 ? '1' : '0');
    for (var i = 0; i < FACETS.length; i += 1) {
      item.setAttribute('data-twrd-f-' + FACETS[i], String(record[FACETS[i]] || '|'));
    }

    var link = document.createElement('a');
    link.className = 'twrd-xcard__link';
    link.href = record.url || '#';

    if (record.image) {
      var img = document.createElement('img');
      img.className = 'twrd-xcard__img';
      img.src = record.image;
      img.alt = '';
      img.loading = 'lazy';
      link.appendChild(img);
    }

    var title = document.createElement('span');
    title.className = 'twrd-xcard__title';
    title.textContent = record.title || '';
    link.appendChild(title);

    var price = document.createElement('span');
    price.className = 'twrd-xcard__price';
    price.textContent = record.priceText || '';
    link.appendChild(price);

    item.appendChild(link);
    return item;
  }

  /* Flytter kortene ved at appende dem i den faerdige raekkefoelge. At appende
     en node der allerede staar i griddet flytter den, saa en enkelt runde er
     nok, og ingen node bliver lagt mod en foraeldet position. */
  function applySort(grid) {
    var plan = planGrid(Array.prototype.slice.call(grid.children), comparatorFor(state.sort, readNode));
    for (var i = 0; i < plan.length; i += 1) grid.appendChild(plan[i]);
  }

  function countText(node, value) {
    if (!node) return;
    node.textContent = value > 0 ? '(' + value + ')' : '(0)';
  }

  function isOn(facet, value) {
    if (facet === 'stock') return state.stock === true;
    return !!state[facet] && state[facet].indexOf(value) !== -1;
  }

  /* Antal pr. valg, regnet paa HELE datasaettet. Derfor er "Black (7)" rigtigt
     for kollektionen og ikke kun for den hentede side. */
  function paintCounts(products) {
    var panel = drawer();
    if (!panel) return;
    var buttons = panel.querySelectorAll('[data-twrd-facet]');
    for (var i = 0; i < buttons.length; i += 1) {
      var button = buttons[i];
      var facet = button.getAttribute('data-twrd-facet');
      var value = valueOf(button);
      var hits = countFor(products, state, facet, value);
      countText(button.querySelector('[data-twrd-count]'), hits);
      button.classList.toggle('is-empty', hits === 0 && !isOn(facet, value));
    }
  }

  function paintControls() {
    var panel = drawer();
    if (panel) {
      var buttons = panel.querySelectorAll('[data-twrd-facet]');
      for (var i = 0; i < buttons.length; i += 1) {
        var on = isOn(buttons[i].getAttribute('data-twrd-facet'), valueOf(buttons[i]));
        buttons[i].classList.toggle('is-on', on);
        buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }

      var sorts = panel.querySelectorAll('[data-twrd-sortkey]');
      for (var s = 0; s < sorts.length; s += 1) {
        var picked = sorts[s].getAttribute('data-twrd-sortkey') === state.sort;
        sorts[s].classList.toggle('is-on', picked);
        sorts[s].setAttribute('aria-pressed', picked ? 'true' : 'false');
      }
    }

    /* Antal aktive filtre i "Filter & sort (2)" paa telefon. Sort taeller ikke. */
    var active = activeCount(state);
    var badges = document.querySelectorAll('[data-twrd-fcount]');
    for (var n = 0; n < badges.length; n += 1) {
      badges[n].textContent = active > 0 ? '(' + active + ')' : '';
      badges[n].hidden = active === 0;
    }

    /* Stoerrelses-pillerne over griddet spejler den samme state. */
    var chips = document.querySelectorAll('[data-twrd-chip][data-twrd-size]');
    for (var c = 0; c < chips.length; c += 1) {
      var size = norm(chips[c].getAttribute('data-twrd-size'));
      var chipOn = state.size.indexOf(size) !== -1;
      chips[c].classList.toggle('is-active', chipOn);
      chips[c].setAttribute('aria-pressed', chipOn ? 'true' : 'false');
    }
  }

  function paintTotals(shown, matches) {
    var text = totalsText(shown, matches);
    var totalNode = document.querySelector('.js-results-total .collection-main__count-text');
    if (totalNode) totalNode.textContent = text;
    /* Phone bar: the number alone. */
    var numberNode = document.querySelector('.js-results-total [data-twrd-count-n]');
    if (numberNode) numberNode.textContent = String(matches);

    var showing = document.querySelector('.js-infinite-showing-count');
    var all = document.querySelector('.js-infinite-total-count');
    if (showing) showing.textContent = String(shown);
    if (all) all.textContent = String(matches);

    var applyNode = document.querySelector('[data-twrd-fd-applytext]');
    if (applyNode) applyNode.textContent = 'Show ' + matches + (matches === 1 ? ' product' : ' products');
  }

  /* Ren: antal valgte filtervaerdier plus lager-toggle. */
  function activeCount(filters) {
    var total = filters.stock === true ? 1 : 0;
    for (var i = 0; i < FACETS.length; i += 1) {
      total += (filters[FACETS[i]] || []).length;
    }
    return total;
  }

  function anyChoice(filters) {
    for (var i = 0; i < FACETS.length; i += 1) {
      if ((filters[FACETS[i]] || []).length) return true;
    }
    return filters.stock === true;
  }

  /* Hele kollektionen er kendt: filtrer, tegn manglende kort, tael aerligt. */
  function applyFromDataset(grid, data) {
    var matched = filterProducts(data.products, state);
    var wanted = {};
    for (var m = 0; m < matched.length; m += 1) wanted[matched[m].handle] = true;

    var nodes = items(grid);
    var present = {};
    var shown = 0;
    for (var i = 0; i < nodes.length; i += 1) {
      var handle = nodes[i].getAttribute('data-twrd-f-handle') || '';
      if (handle) present[handle] = true;
      /* Uden handle (gammelt cachet kort) matcher vi paa kortets egne data. */
      var keep = handle
        ? Object.prototype.hasOwnProperty.call(wanted, handle)
        : matchesProduct(recordFromNode(nodes[i]), state, null);
      if (keep) {
        nodes[i].removeAttribute('data-twrd-hidden');
        shown += 1;
      } else {
        nodes[i].setAttribute('data-twrd-hidden', 'true');
      }
    }

    /* Traeffere paa senere sider har intet kort endnu. Tegn dem. */
    for (var j = 0; j < matched.length; j += 1) {
      if (Object.prototype.hasOwnProperty.call(present, matched[j].handle)) continue;
      grid.appendChild(buildCard(matched[j], grid));
      present[matched[j].handle] = true;
      shown += 1;
    }

    applySort(grid);
    paintCounts(data.products);
    paintControls();
    paintTotals(shown, matched.length);
  }

  /* Uden datasaet kan vi kun se de hentede kort. Tallene siger det aabent. */
  function applyFromDom(grid) {
    var nodes = items(grid);
    var records = [];
    var shown = 0;
    for (var i = 0; i < nodes.length; i += 1) {
      var record = recordFromNode(nodes[i]);
      records.push(record);
      if (matchesProduct(record, state, null)) {
        nodes[i].removeAttribute('data-twrd-hidden');
        shown += 1;
      } else {
        nodes[i].setAttribute('data-twrd-hidden', 'true');
      }
    }

    applySort(grid);
    paintCounts(records);
    paintControls();
    paintTotals(shown, shown);
  }

  function apply() {
    var grid = root();
    if (!grid) return;

    var data = datasetOf();
    if (data && !data.partial) {
      applyFromDataset(grid, data);
      return;
    }

    /* For stor kollektion til JSON: lad serveren filtrere, hvis den kan. */
    if (data && data.partial && data.nativeFilters && anyChoice(state)) {
      window.location.assign(window.location.pathname + '?' + serverQuery(state));
      return;
    }

    applyFromDom(grid);
  }

  function toggle(facet, value) {
    if (facet === 'stock') {
      state = Object.assign({}, state, { stock: !state.stock });
      return;
    }
    if (FACETS.indexOf(facet) === -1) return;
    var at = state[facet].indexOf(value);
    var next = at === -1
      ? state[facet].concat([value])
      : state[facet].slice(0, at).concat(state[facet].slice(at + 1));
    var patch = {};
    patch[facet] = next;
    state = Object.assign({}, state, patch);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var facetBtn = target.closest('[data-twrd-facet]');
    if (facetBtn) {
      event.preventDefault();
      toggle(facetBtn.getAttribute('data-twrd-facet'), valueOf(facetBtn));
      apply();
      return;
    }

    var sortBtn = target.closest('[data-twrd-sortkey]');
    if (sortBtn) {
      event.preventDefault();
      var key = sortBtn.getAttribute('data-twrd-sortkey');
      if (SORTS.indexOf(key) !== -1) state = Object.assign({}, state, { sort: key });
      apply();
      return;
    }

    var clearBtn = target.closest('[data-twrd-fd-clear]');
    if (clearBtn) {
      event.preventDefault();
      state = newState();
      apply();
      return;
    }

    /* Stoerrelses-pillerne i baren: samme state, samme apply. */
    var chip = target.closest('[data-twrd-chip][data-twrd-size]');
    if (chip) {
      event.preventDefault();
      if (chip.getAttribute('aria-disabled') === 'true') return;
      toggle('size', norm(chip.getAttribute('data-twrd-size')));
      apply();
    }
  });

  /* Naar temaet re-renderer griddet (sortering i baren, paginering) kommer
     kortene tilbage i serverens raekkefoelge. Klientsorteringen nulstilles,
     valgene beholdes og bliver lagt paa igen. */
  function bind() {
    var searches = document.querySelectorAll('dynamic-product-search');
    for (var i = 0; i < searches.length; i += 1) {
      searches[i].addEventListener('on:dynamic-product-search:loaded', function () {
        cache = { node: null, data: null };
        state = Object.assign({}, state, { sort: 'featured' });
        apply();
      });
    }
    apply();
  }

  window.TwrdFilters = {
    state: function () {
      return state;
    },
    apply: apply
  };

  /* Testkrog. Kun naar en testrunner beder om den, saa prod er uroert. */
  if (window.__twrdFilterTest === true) {
    window.__twrdFilter = {
      FACETS: FACETS,
      newState: newState,
      norm: norm,
      hasToken: hasToken,
      matchesProduct: matchesProduct,
      filterProducts: filterProducts,
      sortProducts: sortProducts,
      comparatorFor: comparatorFor,
      readRecord: readRecord,
      readNode: readNode,
      orderCards: orderCards,
      planGrid: planGrid,
      countFor: countFor,
      totalsText: totalsText,
      parseDataset: parseDataset,
      serverQuery: serverQuery
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
